module.exports = __webpack_public_path__ + "img/symbol_5.292bd22a.png";